import { getFirebaseAuth } from './firebase';
import { readOpsIdToken } from './idTokenStore';

/** Firebase ID token for API auth when session cookie is unavailable. */
export async function firebaseAuthHeaders(): Promise<Record<string, string>> {
  if (typeof window === 'undefined' || process.env.NEXT_PUBLIC_E2E_MOCK_UID) {
    return {};
  }
  const stored = readOpsIdToken();
  if (stored) {
    return {
      Authorization: `Bearer ${stored}`,
      'X-Firebase-ID-Token': stored,
    };
  }
  try {
    const user = getFirebaseAuth().currentUser;
    if (!user) return {};
    const token = await user.getIdToken();
    return {
      Authorization: `Bearer ${token}`,
      'X-Firebase-ID-Token': token,
    };
  } catch {
    return {};
  }
}
